import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Solicitacao from 'Interface/Solicitacoes';

interface Props {
  dados: Solicitacao;
}

const Lista = ({ dados }: Props): React.ReactElement => (
  <div className="d-flex border-bottom align-items-center py-2 px-3 justify-content-between">
    <div className="d-flex align-items-center w-100 position-relative">
      <Link to={`/admin/solicitacoes/visualizar/${dados.id}`}>
        <Imagem
          src={dados.cliente?.imagem}
          alt={dados.cliente?.nome}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="ms-3 fs-4 text-truncate">
        <Link
          to={`/admin/solicitacoes/visualizar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.titulo.cortar(50)}
          <small className="d-block fs-6 text-muted">
            {dados.cliente?.nome}
          </small>
        </Link>
      </div>
    </div>
    <BrowserView className="d-flex align-items-center">
      <div className="text-end">
        {dados.status == 0 && (
          <Icone nome="clock" className="text-warning fs-3" />
        )}
        {dados.status == 1 && (
          <Icone nome="headset" className="text-primary fs-3" />
        )}
        {dados.status == 2 && (
          <Icone nome="check2-circle" className="text-success fs-3" />
        )}
      </div>
      {dados.status >= 1 && (
        <div className="ms-5 fs-5 text-end">
          {dados.atendente?.nome}
          <small className="d-flex fs-6 text-muted text-nowrap justify-content-end">
            <Icone nome="headset" className="me-2" />
            Atendido por
          </small>
        </div>
      )}
      <div className="ms-5 fs-5 text-end">
        {dados.criado.data().toLocaleString()}
        <small className="d-flex fs-6 text-muted justify-content-end">
          <Icone nome="calendar" className="me-2" />
          Criado em
        </small>
      </div>
    </BrowserView>
  </div>
);

export default Lista;
